var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35547 8.9528H6.79557C8.23568 8.9528 8.95573 8.23275 8.95573 6.79264V5.35254C8.95573 3.91243 8.23568 3.19238 6.79557 3.19238H5.35547C3.91536 3.19238 3.19531 3.91243 3.19531 5.35254V6.79264C3.19531 8.23275 3.91536 8.9528 5.35547 8.9528Z",
    stroke: "#636980",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 8.9528H15.4362C16.8763 8.9528 17.5964 8.23275 17.5964 6.79264V5.35254C17.5964 3.91243 16.8763 3.19238 15.4362 3.19238H13.9961C12.556 3.19238 11.8359 3.91243 11.8359 5.35254V6.79264C11.8359 8.23275 12.556 8.9528 13.9961 8.9528Z",
    stroke: "#636980",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 17.5934H15.4362C16.8763 17.5934 17.5964 16.8734 17.5964 15.4333V13.9932C17.5964 12.5531 16.8763 11.833 15.4362 11.833H13.9961C12.556 11.833 11.8359 12.5531 11.8359 13.9932V15.4333C11.8359 16.8734 12.556 17.5934 13.9961 17.5934Z",
    stroke: "#636980",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35547 17.5934H6.79557C8.23568 17.5934 8.95573 16.8734 8.95573 15.4333V13.9932C8.95573 12.5531 8.23568 11.833 6.79557 11.833H5.35547C3.91536 11.833 3.19531 12.5531 3.19531 13.9932V15.4333C3.19531 16.8734 3.91536 17.5934 5.35547 17.5934Z",
    stroke: "#636980",
    strokeWidth: 0.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.31406cec255b7b3121cda5e7c59505fa.svg";
export { ForwardRef as ReactComponent };